import React from 'react';
import { motion } from 'framer-motion';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: React.ReactNode;
  index: number;
}
export function DiaryEntry({
  date,
  title,
  content,
  index
}: DiaryEntryProps) {
  // Alternate slight rotation for organic diary feel
  const rotation = index % 2 === 0 ? -1.5 : 1.5;
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} className="relative max-w-2xl mx-auto mb-16 px-4 md:px-0" data-id="element-27">
      <div className="bg-cardBg p-8 md:p-10 rounded-sm shadow-md border-l-8 border-warmBrown/60 relative" style={{
      transform: `rotate(${rotation}deg)`
    }} data-id="element-28">
        {/* Subtle tape effect */}
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-24 h-8 bg-white/50 rotate-2 shadow-sm" data-id="element-29"></div>

        <div className="mb-6 border-b border-warmBrown/20 pb-4" data-id="element-30">
          <span className="font-handwritten text-3xl text-warmBrown block mb-2" data-id="element-31">
            {date}
          </span>
          <h3 className="font-serif text-2xl md:text-3xl text-forestGreen font-bold" data-id="element-32">
            {title}
          </h3>
        </div>
        <div className="font-serif text-lg leading-relaxed text-gray-800 space-y-4" data-id="element-33">
          {content}
        </div>
      </div>
    </motion.div>;
}